import * as React from 'react';
import { renderContent } from './renderContent';
import { List } from '../../../../components/VillageAddingBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export var renderSpecification = function renderSpecification(specification) {
  return specification.map(function (spec) {
    switch (spec.type) {
      case 'text':
        return renderContent(spec.value);
      case 'list':
        {
          var _spec$value = spec.value,
            text = _spec$value.text,
            items = _spec$value.items;
          return /*#__PURE__*/_jsx(List, {
            text: renderContent(text),
            items: items.map(function (item, index) {
              return /*#__PURE__*/_jsx("li", {
                children: renderContent(item)
              }, index);
            })
          });
        }
      default:
        return null;
    }
  });
};